export default __webpack_public_path__ + "static/media/bar-graph.afd1b2fb.svg";